module.exports = __webpack_public_path__ + "static/media/euro.b7b9db11.png";